export const BLUE_BACKGROUND_DARK = '#E8F2FF';
export const BLUE_BACKGROUND_LIGHT = '#F5FAFF';
export const GRAY_BACKGROUND_DARK = '#DEDEDE';
export const GRAY_BACKGROUND_LIGHT = '#EEEEEE';
export const PURPLE_BACKGROUND_DARK = '#FAF5FF';
export const PURPLE_BACKGROUND_LIGHT = '#FDFAFF';
export const YELLOW_BACKGROUND_DARK = '#FFFFDA';
export const YELLOW_BACKGROUND_LIGHT = '#FFFFF2';

export const DARK_GREY_LETTERING = '#999999';
export const GREEN_LETTERING = '#33AA33';
export const RED_LETTERING = '#CC3333';
export const EMPASIZED_LETTERING = '#555';
export const NORMAL_LETTERING = '#959595';

// Creating a quadratic formula based on specific column sizing needed to accommodate various mobile screen widths. 
// Alternatives like mapping screen sizes to their corresponding linear growth rate and curvature factor multipliers
// risk missing values if a new or unknown device screen size is used. BFIA-4098
export const curvatureFactor = 0.00057; // Factor for the screen width squared term
export const linearGrowthRate = 0.2348; // Growth rate for the linear screen width term (non-ios)
export const iosLinearGrowthRate = 0.2248; // Growth rate for the linear screen width term